import { render, staticRenderFns } from "./simpleSelect.vue?vue&type=template&id=05655bad&"
import script from "./simpleSelect.vue?vue&type=script&lang=js&"
export * from "./simpleSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../whitelabel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports